import { render, staticRenderFns } from "./add-limit.vue?vue&type=template&id=91499414"
import script from "./add-limit.vue?vue&type=script&lang=js"
export * from "./add-limit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports